import { render } from "./StatusMaster.vue?vue&type=template&id=3254dc3b&scoped=true"
import script from "./StatusMaster.vue?vue&type=script&lang=js"
export * from "./StatusMaster.vue?vue&type=script&lang=js"

import "./StatusMaster.vue?vue&type=style&index=0&id=3254dc3b&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3254dc3b"]])

export default __exports__